export enum Resolution {
    "min" = "(min-width:415px)",
    "max" = "(max-width:415px)"
}